module.exports = (s) => {
  return [
    {
      name: '转化名称',
      value: 'name',
      align: 'center',
      width: '250px',
      overflow: false,
    },
    {
      name: '转化id',
      value: 'type_id',
      align: 'center',
      width: '130px',
      overflow: false,
    },
    {
      name: '转化来源',
      value: 'convert_source_type',
      overflow: false,
      align: 'center',
      width: '120px',
      format: (row, cell, cellValue) => {
        return s.enum_list['convert_source_type'].find(item => item.key === cellValue)?.label;
      },
    },
    {
      name: '状态',
      value: 'opt_status',
      align: 'center',
      format: (row, cell, cellValue) => {
        const type = {
          'AD_CONVERT_OPT_STATUS_ENABLE': '启动',
          'AD_CONVERT_OPT_STATUS_PAUSE': '暂停',
        };
        return type[cellValue] || '-';
      },
    },
    {
      name: '转化类型 ',
      value: 'convert_type',
      align: 'center',
      width: '120px',
      format: (row, cell, cellValue) => {
        return s.enum_list['convert_type'].find(item => item.key === cellValue)?.label;
      },
    },
    {
      name: ' 应用类型',
      value: 'app_type',
      align: 'center',
      format: (row, cell, cellValue) => {
        return s.enum_list['app_type'].find(item => item.key === cellValue)?.label;
      },
    },
    {
      name: ' 直达链接',
      value: 'open_url',
      align: 'center',
      width: '250px',
      overflow: false,
      format: (row, cell, cellValue) => {
        return cellValue || '-';
      },
    },
    {
      name: ' 下载地址',
      value: 'download_url',
      align: 'center',
      width: '250px',
      overflow: false,
      format: (row, cell, cellValue) => {
        return cellValue || '-';
      },
    },
    {
      name: ' 转化路径',
      value: 'convert_xpath_value',
      align: 'center',
      format: (row, cell, cellValue) => {
        return cellValue || '-';
      },
    },
    {
      name: ' 落地页链接',
      value: 'external_url',
      align: 'center',
      width: '250px',
      overflow: false,
      format: (row, cell, cellValue) => {
        return cellValue || '-';
      },
    },
    {
      name: ' APP ID',
      value: 'app_id',
      align: 'center',
    },
    {
      name: '展示监测链接',
      value: 'display_track_url',
      align: 'center',
      format: (row, cell, cellValue) => {
        return cellValue || '-';
      },
    },
    {
      name: '点击监测链接',
      value: 'action_track_url',
      align: 'center',
      format: (row, cell, cellValue) => {
        return cellValue || '-';
      },
    },
    {
      name: '展示监测链接',
      value: 'display_track_url',
      align: 'center',
      format: (row, cell, cellValue) => {
        return cellValue || '-';
      },
    },
    {
      name: '更新时间',
      value: 'modify_time',
      width: '160px',
      align: 'center',
      overflow: false,
    },
    {
      name: '创建时间',
      value: 'create_time',
      align: 'center',
      width: '160px',
      overflow: false,
    },

  ];
};
